import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ChakraProvider, Box } from '@chakra-ui/react';

// Components
import Header from './components/Header';
import Footer from './components/Footer';

// Pages
import Home from './pages/Home';
import About from './pages/About';
import Stats from './pages/Stats';
import Privacy from './pages/Privacy';
import Contact from './pages/Contact';

function App() {
  return (
    <ChakraProvider>
      <Router>
        <Box 
          minH="100vh" 
          display="flex" 
          flexDirection="column"
          bg="gray.50"
        >
          <Header />
          <Box flex="1">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/stats" element={<Stats />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/contact" element={<Contact />} />
            </Routes>
          </Box>
          <Footer />
        </Box>
      </Router>
    </ChakraProvider>
  );
}

export default App;
